export interface TrackSample {
  /** Seconds into the video. */
  t: number;
  lat: number;
  lon: number;
  abs_alt?: number;
  rel_alt?: number;
  yaw?: number;
  pitch?: number;
  roll?: number;
  focal_len?: number;
}

export interface TrackJson {
  schemaVersion: number;
  samples: TrackSample[];
}

/** Fetch and parse a flight's `track.json` from a presigned URL. */
export async function fetchTrack(url: string): Promise<TrackSample[]> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`track.json fetch failed: HTTP ${res.status}`);
  const json = (await res.json()) as TrackJson;
  return json.samples;
}
